import { createSelector } from 'reselect';
import { get, isEmpty } from 'lodash';
import PAGES from 'constants/pages';
import { detailsParamsToKey } from './helpers';
import { RootStateType } from '../rootReducer';

export const selectPages = (state: RootStateType) => state.pages;

export const selectPageIsLoading = createSelector(
  selectPages,
  (_, props) => props,
  (pages, { pageId, params }) => {
    const path = [pageId];
    if (pageId !== PAGES.LIVE_TV && !isEmpty(params)) path.push(detailsParamsToKey(params));

    return get(pages, [...path, 'isLoading'], false) as boolean;
  },
);

export const selectPageData = createSelector(
  selectPages,
  (_, props) => props,
  (pages, { pageId, params }) => {
    if (pageId === PAGES.LIVE_TV && params) {
      const content = get(pages, [pageId, 'data', 'content']);

      return (content || []).find(({ id }) => id === params.id);
    }
    const path = [pageId];
    if (!isEmpty(params)) path.push(detailsParamsToKey(params));

    return get(pages, [...path, 'data'], null);
  },
);
